import React from "react";

const BusinessText = ({ btext }) => {
  return <div className="b-text">{btext}</div>;
};

export default BusinessText;
